import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

export function withNavigation(WrappedComponent) {
    return function WithNavigationComponent(props) {
        const navigate = useNavigate();
        const params = useParams();
        const location = useLocation();


        // Simula las props clásicas de react-router v5
        return (
            <WrappedComponent
                {...props}
                navigate={navigate}
                match={{ params }}
                location={location}
            />
        );
    };
}